import React, { Component } from "react";

import Base from "../../../components/Base";
import api from "../../../services/api";
import handleError from "../../../services/apiErrorHandler";

import "../styles.css";
import { Button, Modal } from "antd";

export default class Causador extends Component {
  state = {
    loading: false
  };

  handleExecutar = async () => {
    const planilha = document.getElementById("causador_file").files[0];

    if (planilha == null) {
      Modal.error({
        title: "Erro",
        content: "Selecione a planilha de entrada!"
      });
      return;
    }

    this.setState({
      loading: true
    });

    const formData = new FormData();
    formData.append("atualiza_planilha", planilha);

    await api
      .post("/crawlers/causador/", formData, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      })
      .then(() => {
        Modal.success({
          title: "Atividade solicitada",
          content: (
            <div>
              Atividade solicitada com sucesso! Clique&nbsp;
              <a href="/atividades">aqui</a> para ver suas atividades.
            </div>
          )
        });
      })
      .catch(error => {
        Modal.error({
          title: "Erro",
          content: handleError(error)
        });
      });

    this.setState({
      loading: false
    });
  };

  render() {
    return (
      <Base title="Causador">
        <div className="cw__container">
          <div className="cw__title">Atualizar causador</div>
          <br />
          <p>
            * Ao fazer upload de uma planilha, o crawler irá atualizar o campo
            "Causador" na página da HDI de acordo com oque estiver na planilha
            enviada.
          </p>
          <p>
            * O cabeçalho da planilha deve seguir o formato:{" "}
            <b>PASTA | CAUSADOR</b>
          </p>
          <div className="cw__inputs">
            <input
              type="file"
              id="causador_file"
              placeholder="Selecione a planilha de entrada"
            />
            <Button
              type="primary"
              onClick={this.handleExecutar}
              style={{ marginLeft: "25px" }}
              loading={this.state.loading}
            >
              Executar
            </Button>
          </div>
        </div>
      </Base>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Crawlers/Causador/index.js